export default __webpack_public_path__ + "static/media/mail_michelin_david_zaragoza.e586da52.jpg";